import {Routes} from 'constants/routes';

import React from 'react';

import {faCauldron} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Icon from 'components/Icon/Icon';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {useNavigate} from 'react-router';
import {setSingleBreweryAC} from 'store/singleBrewery/singleBrewerySlice';
import Brewery from 'typescript/models/Brewery';
import {cutWord} from 'utils/helpers/cutWord';

interface IProps {
  brewery: Brewery;
}

export const BreweriesRow = ({brewery}: IProps) => {
  const navigate = useNavigate();
  const dispatch = useSetGlobalState();

  const {name, country, kind, brewery_logo} = brewery.attributes;

  const handleView = () => {
    dispatch(setSingleBreweryAC(brewery));
    navigate(`${Routes.BREWERIES_VIEW}/${brewery.id}`);
  };

  const handleEdit = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();

    dispatch(setSingleBreweryAC(brewery));
    navigate(`${Routes.BREWERIES_EDIT}/${brewery.id}`);
  };

  return (
    <div className="breweries-table-body__row" role="button" tabIndex={0} onClick={handleView}>
      <div className="breweries-table-body__name">
        {brewery_logo ? (
          <img src={brewery_logo} alt="Brewery logo" />
        ) : (
          <span>
            <FontAwesomeIcon icon={faCauldron} />
          </span>
        )}
        {name}
      </div>
      <div className="breweries-table-body__cell">{kind}</div>
      <div className="breweries-table-body__cell">{cutWord(country, 30)}</div>
      <div className="breweries-table-body__empty">
        <button onClick={(e) => handleEdit(e)}>
          <Icon icon="edit" />
        </button>
      </div>
    </div>
  );
};
